module.exports = __webpack_public_path__ + "img/Man-gesturing-and-forklift-2-1200-COMPRESSED.01d226bb.gif";